export const ApplicationConstant = {
    ApplicationID : 21,
    clientId : 13,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
